export const selectReportContextAfterTombstone = ({
  displayedContext,
  remainingContexts,
  activeViewportIndex,
  clearedViewportIndex,
}) => {
  if (displayedContext?.viewportIndex !== clearedViewportIndex) return displayedContext || null;
  const activeContext = remainingContexts?.[activeViewportIndex];
  if (activeContext) return activeContext;
  return Object.values(remainingContexts || {}).find(Boolean) || null;
};

export const selectReportContextAfterUpdate = ({
  displayedContext,
  incomingContext,
  activeViewportIndex,
}) => {
  if (!incomingContext || incomingContext.viewportIndex == null) return displayedContext || null;
  if (
    !displayedContext
    || incomingContext.viewportIndex === activeViewportIndex
    || incomingContext.viewportIndex === displayedContext.viewportIndex
  ) return incomingContext;
  return displayedContext;
};
